import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useApp } from "@/context";
import http from "@/api";

export default function BloggersRow() {
  const { lang } = useApp();
  const ar = lang === "ar";
  const [list, setList] = useState([]);

  useEffect(() => {
    http.get("/public/bloggers").then(({ data }) => setList(data || [])).catch(() => {});
  }, []);

  if (!list.length) return null;

  return (
    <section className="space-y-2.5" data-testid="home-bloggers-row">
      <h2 className={`${ar ? "font-display-ar" : "font-display-en"} text-xl sm:text-2xl font-bold`}>
        {ar ? "اختيارات البلوقرز 🛍" : "Bloggers' picks 🛍"}
      </h2>
      <div className="flex gap-3 overflow-x-auto scroll-x-hide -mx-4 px-4 sm:mx-0 sm:px-0 pb-1 snap-x">
        {list.map((b) => (
          <Link key={b.promo_code} to={`/b/${encodeURIComponent(b.promo_code)}`}
                className="card-soft shrink-0 snap-start p-3 flex flex-col items-center text-center"
                style={{ width: 150 }} data-testid={`blogger-card-${b.promo_code}`}>
            {b.avatar ? (
              <img src={b.avatar} alt="" className="w-16 h-16 rounded-full object-cover border-2"
                   style={{ borderColor: "var(--primary)" }} />
            ) : (
              <div className="w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center text-xl font-bold">
                {(b.display_name || "B")[0]}
              </div>
            )}
            <div className="text-xs font-bold mt-2 line-clamp-1">{b.display_name}</div>
            <div className="text-[10px] opacity-50 font-mono mt-0.5" dir="ltr">{b.promo_code}</div>
            <div className="text-[10px] opacity-60 mt-1">
              {b.items_count} {ar ? "منتج مختار" : "picks"}
            </div>
            {(b.preview_images || []).length > 0 && (
              <div className="flex gap-1 mt-2">
                {b.preview_images.slice(0, 3).map((img, i) => (
                  <img key={i} src={img} alt="" className="w-8 h-8 rounded-lg object-cover"
                       onError={(e) => { e.currentTarget.style.display = "none"; }} />
                ))}
              </div>
            )}
            <span className="chip !text-[9.5px] !py-0.5 mt-2">{ar ? "شاهد اختياراته ←" : "View picks →"}</span>
          </Link>
        ))}
      </div>
    </section>
  );
}
